import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './Services/AuthGard.service';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Configuration } from './config/config';
import { HttpErrorService } from './Services/http-error.service';
import { TranslateService } from '@ngx-translate/core';
declare let $;
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  errorServerMsg: any;

  constructor(public authService: AuthService, private httpErrorService: HttpErrorService, private translate: TranslateService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let mainUrl = new URL(request.url);
    if (mainUrl.origin + '/' == Configuration.Server) {
      if (this.authService.getJwtToken()) {
        request = this.addToken(request, this.authService.getJwtToken());
      }
    } else {
      if (mainUrl.pathname.includes('i18n') && mainUrl.pathname.split('/')[1] == 'i18n') {
        let URL = mainUrl.pathname;
        request = this.checkCommResource(request, URL, false);
      }
    }

    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(request, next);
      } if (error instanceof HttpErrorResponse && error.status === 0) {
        this.httpErrorService.showError(
          `Backend returned code ${error.status}, `
          + `body was: ${JSON.stringify(error.error)}`);
        $("#preloader").css('display', 'none');
        return next.handle(request);
      } if (error instanceof HttpErrorResponse && error.status === 403) {
        if (mainUrl.pathname.split('/')[1] == 'i18n') {
          const dupReq = this.checkCommResource(request, '/i18n/English.json', true);
          return next.handle(dupReq);
        } else {
          this.httpErrorService.showError(
            `Backend returned code ${error.status}, `
            + `body was: ${JSON.stringify(error.error)}`);
          $("#preloader").css('display', 'none');
          return Observable.throw(error);
        }
      } else {
        // this.httpErrorService.showError(
        //   `Backend returned code ${error.status}, `
        //   + `body was: ${JSON.stringify(error.error)}`);

        // this.httpErrorService.showError(
        //   `The request processing has failed because of internal Server error.`);

        this.httpErrorService.showError("");

        $("#preloader").css('display', 'none');
        return Observable.throw(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Authorization': `${token}`,
        'Referrer-Policy': 'no-referrer',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true'
      }
    });
  }

  private checkCommResource(request: HttpRequest<any>, URL: string, isEnglish?: boolean) {
    console.log("~~~Old URL: ", URL);
    let finalUrl = '';
    let CommResources = localStorage.getItem('CommResources') ? JSON.parse(localStorage.getItem('CommResources')) : null;

    if (CommResources && CommResources.resource_config && CommResources.resource_config.length > 0 && CommResources.resource_config[0].Resource) {

      let lang_name = URL && URL.length > 0 ? URL.split('/')[2] : '';
      lang_name = lang_name && lang_name.length > 0 ? lang_name.split('.')[0] : '';

      let EngFile = CommResources.resource_config[0].Resource["English"] == true ?
        Configuration.S3_CommonResources + CommResources.community_id + '/Resources/' : 'i18n/';

      if ((lang_name != null && lang_name == 'English' || isEnglish) && EngFile) {
        finalUrl = Configuration.S3_BucketObjectURL + EngFile + 'English.json';
        console.log("~~~Final URL without null : ", finalUrl);
        return request.clone({ url: finalUrl });
      } else {
        let fileName = CommResources.resource_config[0].Resource[lang_name] == true ?
          Configuration.S3_CommonResources + CommResources.community_id + '/Resources/' : 'i18n/';


        if (URL.includes('/i18n/')) {
          console.log("URL with dynamic test1", URL);
          URL = URL.replace('/i18n/', fileName);
          URL = URL.replace('null', "English");
          console.log("URL with dynamic test2", URL);
          console.log("~~~Final URL null test : ", Configuration.S3_BucketObjectURL + URL);
          return request.clone({ url: Configuration.S3_BucketObjectURL + URL });
        } else {
          return request;
        }
      }

    } else {
      if (URL.includes('/i18n/')) {
        let lang_name = URL && URL.length > 0 ? URL.split('/')[2] : '';
        lang_name = lang_name && lang_name.length > 0 ? lang_name.split('.')[0] : '';

        if (lang_name && lang_name.length > 0) {
          console.log("lang_name with dynamic test", lang_name);
          let pattern = /^[a-zA-Z]+$/;
          console.log(pattern.test(lang_name))
          // || pattern.test(lang_name)
          if (lang_name == "null") {
            lang_name = "English";
            console.log("if null lang name", lang_name);
          }
          finalUrl = Configuration.S3_BucketObjectURL + 'i18n/' + lang_name + '.json';
          console.log("final url with length gt 0", finalUrl);
          console.log("~~~Final URL length gt 0: ", finalUrl);
          return request.clone({ url: finalUrl });
        } else if (lang_name == null) {
          finalUrl = Configuration.S3_BucketObjectURL + 'i18n/English.json';
          console.log("~~~Final URL if lang name null : ", finalUrl);
          return request.clone({ url: finalUrl });
        }
        else {
          finalUrl = Configuration.S3_BucketObjectURL + 'i18n/English.json';
          console.log("~~~Final URL else : ", finalUrl);
          return request.clone({ url: finalUrl });
        }
      } else {
        return request;
      }
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.token);
          return next.handle(this.addToken(request, token.token));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token.token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt.token));
        }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/token.interceptor.ts